import React from 'react';
import PropTypes from 'prop-types';

const Edit = ({ fill = 'var(--PRIMARY)', ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.615 4.02002L13.98 2.38502C13.7011 2.11909 13.3304 1.97073 12.945 1.97073C12.5596 1.97073 12.189 2.11909 11.91 2.38502L9.34502 4.95002L2.28752 12C2.07786 12.2117 1.9594 12.4971 1.95752 12.795V14.925C1.95752 15.0718 1.98642 15.2171 2.04258 15.3527C2.09874 15.4882 2.18106 15.6114 2.28483 15.7152C2.3886 15.819 2.51179 15.9013 2.64737 15.9575C2.78295 16.0136 2.92827 16.0425 3.07502 16.0425H5.19752C5.34418 16.0513 5.4911 16.0299 5.62914 15.9796C5.76719 15.9293 5.89343 15.8511 6.00002 15.75L14.1375 7.56752L15.6375 6.06752C15.8939 5.78689 16.0342 5.41941 16.03 5.03933C16.0258 4.65926 15.8775 4.29494 15.615 4.02002ZM5.01752 14.52H3.51752V13.02L10.4475 6.09002L10.7925 6.42752L11.97 7.61252L5.01752 14.52ZM13.05 6.47252L12 5.40002L11.55 4.95002L12.975 3.53252L14.475 5.03252L13.05 6.47252Z"
      fill={fill}
    />
  </svg>
);

Edit.propTypes = {
  fill: PropTypes.string,
};

export default Edit;
